exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root-about-page[data-v-6cab50b1]{display:flex;justify-content:center;overflow:hidden}.root-about-page .about-page[data-v-6cab50b1]{min-height:100vh;width:100%}", ""]);

// exports
